import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {SiteKeyEnum} from "../enums/site-key.enum";

@Injectable({
	providedIn: 'root'
})
export class AnalyticsService {

	constructor() {
	}

	public initialize(company: string) {
		console.log('initialize company', company);
		let analytics_id: string = environment.analytics_id_koutravo;
		if (company === SiteKeyEnum.SELOGER) {
			analytics_id = environment.analytics_id_seloger;

			this.loadPixel(environment.pixel_id_seloger);
		}

		console.log('initialize analytics_id', analytics_id);
		// Dynamically add analytics scripts to document head
		try {
			const url = 'https://www.googletagmanager.com/gtag/js?id=';
			const gTagScript = document.createElement('script');
			gTagScript.async = true;
			gTagScript.setAttribute("data-cookie-consent", "tracking");
			gTagScript.src = `${url}${analytics_id}`;
			document.head.appendChild(gTagScript);

			const dataLayerScript = document.createElement('script');
			dataLayerScript.innerHTML = `
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());
				gtag('config', '${analytics_id}', {
					send_page_view: false,
					linker: {
						domains: ['koutravo.fr', 'calculator.koutravo.fr']
					}
				});`;
			document.head.appendChild(dataLayerScript);
		} catch (e) {
			console.error('Error adding Google Analytics', e);
		}
	}

	public trackEvent(eventCategory: string, eventLabel: string, eventValue: string): void {
		if (window && (window as any)['gtag']) {
			(window as any)['gtag']('event', eventLabel, {
				event_category: eventCategory,
				event_value: eventValue
			});
		}
	}

	public loadPixel(pixelId: string) {
		if (!window || document.getElementById('meta-pixel') || pixelId == "") {
			return;
		}

		// Create the script element
		const script = document.createElement('script');
		script.id = 'meta-pixel';
		script.innerHTML = `
			!function(f,b,e,v,n,t,s)
			{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
			n.callMethod.apply(n,arguments):n.queue.push(arguments)};
			if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
			n.queue=[];t=b.createElement(e);t.async=!0;
			t.src=v;s=b.getElementsByTagName(e)[0];
			s.parentNode.insertBefore(t,s)}(window, document,'script',
			'https://connect.facebook.net/en_US/fbevents.js');

			fbq('init', '${pixelId}');
			fbq('track', 'PageView');
		`;
		// Append to head
		document.head.appendChild(script);
	}
}
